import { render, staticRenderFns } from "./contactCenShfwOne.vue?vue&type=template&id=b83a36cc&scoped=true&"
import script from "./contactCenShfwOne.vue?vue&type=script&lang=js&"
export * from "./contactCenShfwOne.vue?vue&type=script&lang=js&"
import style1 from "./contactCenShfwOne.vue?vue&type=style&index=1&id=b83a36cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83a36cc",
  null
  
)

export default component.exports